import { useMediaQuery } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { Create, Loading, NumberInput, required, SelectInput, SimpleForm, TextInput, useNotify } from 'react-admin';
import { devises, getAgentListByRole, getAgentRole, has_role, json, modePayement } from '../references.js';

const  CreateVersement =(props,...rest) => {
    const notify = useNotify();
    const [listUserByRole, setListUserByRole] = useState();
    const [fullname, setFullname] = useState('');
    //const [disabledSaveButton, setDisabledSaveButton] = useState(true);
    const [role, setRole] = useState();
    const isSmall = useMediaQuery(theme => theme.breakpoints.down('sm'));
    const { permissions } = props;

   useEffect(() => {
       
        setFullname(localStorage.getItem('fullname'));
        //setRole('ROLE_MANAGER');
        
        fetch(process.env.REACT_APP_URL+'/user/getUserByRoles', { method: 'GET',
                headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json;charset=UTF-8',
                        "Authorization": "Bearer "+ localStorage.getItem('token')
                }
            }
        ).then(json)
        .then((data) => {
            if(data.error){
                notify(data.message, 'warning');
                setListUserByRole([]);
            }  
            else setListUserByRole(data);
            //console.log(data);
            //setListUserByRole(data);
        }).catch((e) => {
            notify("Erreur lors du processus de récupération de la liste des agents !", 'warning')
        });
        
    }, []);


  
    const typeChange=(event)=>{
        setRole(event.target.value);
    }
    
  return (
     
    
   ( !listUserByRole)  ? <Loading /> : 

      <Create {...props}  title={'Création VST - '+fullname}  >
        <SimpleForm  {...props}  submitOnEnter={true}  redirect="show" margin="none" >
        {
         has_role(permissions,'ROLE_MANAGER')  ?   
            <>  
            { isSmall ?
          <SelectInput {...rest} fullWidth source="mode_vst" label="Mode versement" validate={required()} choices={modePayement}  />:
          <SelectInput {...rest} style={{width:'50%'}} source="mode_vst" label="Mode versement" validate={required()} choices={modePayement} />
            }
          </>
            
        : <TextInput  style={{display:'none'}} source="mode_vst"  defaultValue="espece" />
        }
            
          { isSmall ?
              <SelectInput {...rest} fullWidth source="type" label="Type agent" validate={required()} choices={getAgentRole(listUserByRole)} onChange={(event)=>typeChange(event)} />
              :
              <SelectInput {...rest} style={{width:'50%'}} source="type" label="Type agent" validate={required()} choices={getAgentRole(listUserByRole)} onChange={(event)=>typeChange(event)}  />
          } 
         { isSmall ?
              <SelectInput {...rest} fullWidth source="user_rec_id" label="Agent" validate={required()} choices={getAgentListByRole(role,listUserByRole)}  />
              :
              <SelectInput {...rest} style={{width:'50%'}} source="user_rec_id" label="Agent" validate={required()} choices={getAgentListByRole(role,listUserByRole)} />
          }  

        { isSmall ?
              <SelectInput {...rest} fullWidth source="devise" label="Devise" validate={required()} choices={devises}  />
              :
              <SelectInput {...rest} style={{width:'50%'}} source="devise" label="Devise" validate={required()} choices={devises} />
          }

        { isSmall ?
              <NumberInput {...rest} fullWidth source="montant" label="Montant"  validate={required()}/>
              :
              <NumberInput {...rest} style={{width:'50%'}} source="montant" label="Montant" validate={required()}  />
          }

        { isSmall ?
              <TextInput {...rest} fullWidth source="commentaire" label="Commentaire"  />
              :
              <TextInput {...rest} style={{width:'50%'}} source="commentaire" label="Commentaire"   />
          }
        
        
        </SimpleForm>
    </Create> 
    );
};

export default CreateVersement;
